var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserfe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 11.25H10.3889V13.125H14.1667V15L17 12.1875L14.1667 9.375V11.25ZM7.55556 0C5.47778 0 3.77778 1.6875 3.77778 3.75C3.77778 5.8125 5.47778 7.5 7.55556 7.5C9.63333 7.5 11.3333 5.8125 11.3333 3.75C11.3333 1.6875 9.63333 0 7.55556 0ZM7.55556 9.375C3.4 9.375 0 11.0625 0 13.125V15H8.97222C8.68889 14.25 8.5 13.5 8.5 12.6562C8.5 11.5312 8.78333 10.5 9.35 9.46875C8.78333 9.46875 8.21667 9.375 7.55556 9.375Z",
    fill: "#6D0062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserfe);
export default __webpack_public_path__ + "static/media/userfe.275b9de50b6b911a9ab3a13b8ec78ff9.svg";
export { ForwardRef as ReactComponent };